// import { Login } from "../features/authentication/components/login/Login";
import { lazy } from "react";
import { ROUTE_AUTO_LOGIN, ROUTE_AUTO_LOGIN_MAIN } from "./routes";

const Auth = lazy(() => import("../pages/Auth"));
const AutoLogin = lazy(() => import("../pages/AutoLogin"));

export const guestRouting = [
  {
    path: ["/"],
    Page: Auth,
    exact: false,
    props: {},
  },
  {
    path: [ROUTE_AUTO_LOGIN, ROUTE_AUTO_LOGIN_MAIN],
    Page: AutoLogin,
    exact: false,
    props: {},
  },
];
